import { NgModule } from '@angular/core';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { OrganizationService } from '../../../../../../services/organization/organization.service';
import { SharedModule } from '../../../../../shared/shared.module';
import { ToggleSwitchModule } from '../../../../../shared/toggle-switch/toggle-switch.module';
import { DialogDashWidgetSortComponent } from './dialog-dash-widget-sort.component';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { DropListModule } from '../../../../../shared/drop-list/drop-list.module';

@NgModule({
    imports: [
        SharedModule,
        MatDialogModule,
        ToggleSwitchModule,
        MatSlideToggleModule,
        DropListModule,
    ],
    declarations: [DialogDashWidgetSortComponent],
    providers: [
        OrganizationService,
    ],
})
export class DialogDashWidgetSortModule
{
}
